/*
 * 百舸云平台权限配置 - 个人客户权限
 *
 * name                     应用名称
 * version                  应用版本  1.0.0 开始
 * menus                    全部菜单  Array
 *   name                   菜单标识
 *   title                  菜单名称
 *   views                  二级菜单
 *     pc                   pc端  Array
 *       name               菜单标识
 *       title              菜单名称
 *       haveMenuSubpage    一级菜单有子页面
 *       auth               功能权限
 *         name             权限名称
 *         permission       权限值  菜单标识_菜单标识_功能
 *         haveSubpage      二级菜单有子页面
 *         pages            子页面标识  Array
 *
 *     mobile               移动端  Array
 */

export default {
  name: 'BaiGeYun',
  version: '1.0.0',
  menus: [
    {
      name: 'overview',
      title: '概况总览',
      views: {
        pc: [
          {
            name: 'overview',
            title: '概况总览',
            auth: [
              {
                name: '查看',
                permission: 'overview_overview_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'equipmentCenter',
      title: '设备中心',
      views: {
        pc: [
          {
            name: 'deviceManage',
            title: '设备管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'equipmentCenter_deviceManage_view',
                haveSubpage: true,
                pages: ['deviceDetail']
              }
            ]
          },
          {
            name: 'productLineManage',
            title: '产线管理',
            auth: [
              {
                name: '查看',
                permission: 'equipmentCenter_productLineManage_view',
                haveSubpage: true,
                pages: ['productLineDetail']
              }
            ]
          },
          {
            name: 'deviceGroup',
            title: '设备分组',
            auth: [
              {
                name: '查看',
                permission: 'equipmentCenter_deviceGroup_view'
              },
              {
                name: '自定义分组管理',
                permission: 'equipmentCenter_deviceGroup_customerGroup'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'gatewayManage',
      title: '网关管理',
      views: {
        pc: [
          {
            name: 'gatewayManage',
            title: '网关管理',
            haveMenuSubpage: true,
            auth: [
              {
                name: '查看 / 详情',
                permission: 'gatewayManage_gatewayManage_view',
                haveSubpage: true,
                pages: ['gatewayDetail']
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'spaceManageForCustomer',
      title: '空间管理',
      views: {
        pc: [
          {
            name: 'spaceManageForCustomer',
            title: '空间管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'spaceManageForCustomer_spaceManageForCustomer_view'
              },
              {
                name: '清除数据',
                permission: 'spaceManageForCustomer_spaceManageForCustomer_clearData'
              },
              {
                name: '预警设置',
                permission: 'spaceManageForCustomer_spaceManageForCustomer_warnSet'
              },
              {
                name: '刷新',
                permission: 'spaceManageForCustomer_spaceManageForCustomer_refresh'
              },
              {
                name: '更改套餐',
                permission: 'spaceManageForCustomer_spaceManageForCustomer_modifyPackage'
              },
              {
                name: '续费套餐',
                permission: 'spaceManageForCustomer_spaceManageForCustomer_rebuy'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'smsManageForCustomer',
      title: '短信管理',
      views: {
        pc: [
          {
            name: 'smsManageForCustomer',
            title: '短信管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'smsManageForCustomer_smsManageForCustomer_view'
              },
              {
                name: '预警设置',
                permission: 'smsManageForCustomer_smsManageForCustomer_warnSet'
              },
              {
                name: '重新发送',
                permission: 'smsManageForCustomer_smsManageForCustomer_resend'
              },
              {
                name: '购买套餐',
                permission: 'smsManageForCustomer_smsManageForCustomer_buyPackage'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'iotCardManageForCustomer',
      title: '物联卡管理',
      views: {
        pc: [
          {
            name: 'iotCardManageForCustomer',
            title: '物联卡管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_view'
              },
              {
                name: '续费套餐',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_rebuy'
              },
              {
                name: '预警设置',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_warnSet'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'workorderManage',
      title: '工单管理',
      views: {
        pc: [
          {
            name: 'workorderManage',
            title: '工单管理',
            haveMenuSubpage: true,
            auth: [
              {
                name: '查看 / 详情',
                permission: 'workorderManage_workorderManage_view',
                haveSubpage: true,
                pages: ['outWorkorder']
              },
              {
                name: '派单',
                permission: 'workorderManage_workorderManage_assign'
              },
            ]
          }
        ],
        mobile: []
      },
    },
    {
      name: 'systemManageForCustomer',
      title: '系统日志',
      views: {
        pc: [
          {
            name: 'systemManageForCustomer',
            title: '系统日志',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'systemManageForCustomer_systemManageForCustomer_view'
              }
            ]
          }
        ],
        mobile: []
      }
    }
  ]
};
